import { VariantRule } from './PrivacyRightsWrapper.types';

export const DONOT_SELL_SHARE_SECTION_CODE = {
  DONOT_SELL_FETCH_SECTION_CODE: 'permission-to-sell-data-ccpa',
  DONOT_SHARE_FETCH_SECTION_CODE: 'allow-targeted-advertising',
  DONOT_SELL_SUBMIT_SECTION_CODE: 'PERMISSION_TO_SELL_DATA_CCPA',
  DONOT_SHARE_SUBMIT_SECTION_CODE: 'ALLOW_TARGETED_ADVERTISING',
  DONOT_SELL_SHARE_OPTIN_VALUE: 'Y',
};

export const PRIVACY_RIGHTS_API_ENDPOINT = {
  AUTH_SUBMIT_ENDPOINT: '/mi/v1/legal/submitAuthCpra',
  UNAUTH_SUBMIT_ENDPOINT: '/mi/v1/legal/submitUnAuthCpra',
};

export const TAB_OPTIONS = [
  {
    tabTitle: 'U.S. Residents',
    tabValue: 'us',
    tabSubtitle: '',
    isActive: true,
  },
  {
    tabTitle: 'Non U.S Residents',
    tabValue: 'nonus',
    tabSubtitle: '',
    isActive: false,
  },
];

export const GET_PRIVACY_CONSENT_OPERATION_NAME = 'phoenixLegalPrivacyConsentQuery';

export const INITIAL_PRIVACY_RIGHTS_MODEL_DATA = {
  trackingPreferenceSelector: 'js-tracking-pref',
  userNamePrefix: '',
  header: '',
  residentsOptions: [],
  subHeaders: {
    usAuth: '',
    usUnAuth: '',
    nonUSResident: '',
  },
  stateNameSuffix: '',
  statesLabel: '',
  states: [],
  ccpaOptInCountries: [],
  cpraOptInCountries: [],
  statementHeaderForGPC: '',
  statementTitle: '',
  statementTitleAuth: '',
  checkboxTitle: '',
  instructions: [],
  checkboxes: [],
  additionalSection: [],
  form: {
    type: '',
    id: '',
    name: '',
    placeholder: '',
    invalidEmailErrorMessage: '',
  },
  cta: { submitBtnLabel: '', submitBtnId: '', submitBtnName: '' },
  proceedModal: { btnSubmitLabel: '', btnCancelLabel: '', header: '', body: '', confirmationHeader: '' },
  alertMessages: {
    authSuccessfulSubmission: '',
    unAuthSuccessfulSubmission: '',
    profileNotFound: '',
    authProfileIsInEligible: '',
    apiFailed: '',
  },

  // additional params
  subHeading: '',
  uniqueId: '',
};

export const AKAMAI_COUNTRY_CODE_COOKIE = 'akmCC';

export const ONE_TRUST_COOKIE = 'OptanonConsent';

export const VARIANT_RULES: Record<string, VariantRule> = {
  CCPA_OUT_CPRA_OUT: {
    primary: 'CCPA_OUT:CPRA_OUT',
    secondary: 'CPRA_OUT:CCPA_OUT',
    fallback: 'CPRA_OUT',
    individualVariants: ['CCPA_OUT', 'CPRA_OUT'],
    masterVariant: 'MASTER_OUT',
  },

  CCPA_IN_CPRA_IN: {
    primary: 'CCPA_IN:CPRA_IN',
    secondary: 'CPRA_IN:CCPA_IN',
    fallback: 'CPRA_IN',
    individualVariants: ['CCPA_IN', 'CPRA_IN'],
    masterVariant: 'MASTER_IN',
  },

  CCPA_IN_CPRA_OUT: {
    primary: 'CCPA_IN:CPRA_OUT',
    secondary: 'CPRA_OUT:CCPA_IN',
    fallback: 'CPRA_OUT',
    individualVariants: ['CCPA_IN', 'CPRA_OUT'],
  },

  CCPA_OUT_CPRA_IN: {
    primary: 'CCPA_OUT:CPRA_IN',
    secondary: 'CPRA_IN:CCPA_OUT',
    fallback: 'CPRA_IN',
    individualVariants: ['CCPA_OUT', 'CPRA_IN'],
  },
};

export const CONSENT_PAYLOAD_MAPPING = {
  CCPA_IN: {
    consentType: DONOT_SELL_SHARE_SECTION_CODE.DONOT_SELL_SUBMIT_SECTION_CODE,
    optInValue: true,
  },
  CCPA_OUT: {
    consentType: DONOT_SELL_SHARE_SECTION_CODE.DONOT_SELL_SUBMIT_SECTION_CODE,
    optInValue: false,
  },
  CPRA_IN: {
    consentType: DONOT_SELL_SHARE_SECTION_CODE.DONOT_SHARE_SUBMIT_SECTION_CODE,
    optInValue: true,
  },
  CPRA_OUT: {
    consentType: DONOT_SELL_SHARE_SECTION_CODE.DONOT_SHARE_SUBMIT_SECTION_CODE,
    optInValue: false,
  },
} as const;
